import PaymentOrderPage from './OrderPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function MaterialPaymentPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('meta.paymentOrder.title', t('app.payment.payOrderTitle')),
        description: t('meta.paymentOrder.description', t('app.description')),
        keywords: t('meta.paymentOrder.keywords', t('app.keywords')),
    });

    return <PaymentOrderPage kind="material" />;
}
